import { Logo } from '@/assets/logo';
import { LoginForm } from './login/LoginForm';
import { LoginFAQ } from './login/LoginFAQ';

export function Login() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center py-8 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-3xl shadow-sm p-6 md:p-8">
          <div className="flex justify-center mb-6">
            <Logo className="h-12 w-12" />
          </div>
          <h2 className="text-2xl font-bold text-primary-dark text-center mb-8">
            تسجيل الدخول
          </h2>

          <LoginForm />
          <LoginFAQ />
        </div>
      </div>
    </div>
  );
}